import { useQuery } from "@tanstack/react-query";
import { api } from "../../../../api/axios";
import { Platforms } from "./types";

// Single platforms endpoint keyed by backend location id. The view is generic;
// the backend maps each robotics system's platforms + mapped units into one
// shape (LogiCS today, VLC later).
export const usePlatforms = (locationId: number) => {
  return useQuery({
    queryKey: ["platforms", locationId],
    queryFn: async () => {
      const response = await api.get<Platforms>(
        `/platforms/location/${locationId}`
      );
      return response.data;
    },
    refetchInterval: 15000,
  });
};
